import "./excel/main.js";
import "./excel/mixins.js";
import "./kendo.ooxml.js";

export const __meta__ = {
    id: "excel",
    name: "Excel export",
    category: "framework",
    advanced: true,
    mixin: true,
    depends: [ "data", "ooxml" ]
};
